import React, { Component } from "react";
import { connect } from "react-redux";
import { DurableFunctionInstance, DurableFunctionInstanceHelpers } from "../../models/DurableFunctionInstance";

import { IRootState } from "../../store";
import DurableFunctionInstanceStatus from "../DurableFunctionInstanceStatus";

interface MailroomDurableFunctionInstanceStatusProps {
    durableFunctionInstance?: DurableFunctionInstance
    flex?: string;
}

interface MailroomDurableFunctionInstanceStatusState {

}

class MailroomDurableFunctionInstanceStatus extends Component<MailroomDurableFunctionInstanceStatusProps, MailroomDurableFunctionInstanceStatusState> {

    public render() {
        
        let customStatusMessageOverride = undefined;
        let pillColourOverride = undefined;
        if(this.props.durableFunctionInstance)
        {
            const output = DurableFunctionInstanceHelpers.ParseOutput(this.props.durableFunctionInstance);
            if(output !== undefined)
            {
                if(output instanceof(Object) && output.Error)
                {
                    this.props.durableFunctionInstance.runtimeStatus = "Failed";
                    pillColourOverride = "red";
                    customStatusMessageOverride = output.ErrorReason;
                }

                if(this.props.durableFunctionInstance.runtimeStatus === "Failed" && typeof output === "string")
                {
                    customStatusMessageOverride = output;
                }
            }
        }

        return (
            <DurableFunctionInstanceStatus
                durableFunctionInstance={this.props.durableFunctionInstance}
                flex={this.props.flex}
                pillColourForRuntimeStatus={pillColourOverride}
                customStatusMessageOverride={customStatusMessageOverride}
            />
        )
        
    }
}

export default connect((state: IRootState, ownProps: any): MailroomDurableFunctionInstanceStatusProps => {
    return {

    };
})(MailroomDurableFunctionInstanceStatus);